import { render, staticRenderFns } from "./CardTarjaEnqueteTVZWithQRCode.vue?vue&type=template&id=4b4a0d78&scoped=true"
import script from "./CardTarjaEnqueteTVZWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTVZWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTVZWithQRCode.vue?vue&type=style&index=0&id=4b4a0d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a0d78",
  null
  
)

export default component.exports